import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import {
  launcherIconGeneration,
  loadLauncherIconUrl,
  subscribeLauncherIconCache,
} from '../../../services/homeLauncher/launcherIconCache';

/**
 * Renders a launcher image from an authenticated content response.
 * The object URL stays in the session cache until logout, a tenant or dealer
 * context change, or an explicit clear. It is not written to a document.
 */
export default function HomeButtonImage({ assetId, tenantId, alt = '', fallback = null, sx = {} }) {
  const [src, setSrc] = useState('');

  useEffect(() => {
    if (!assetId || !tenantId) return undefined;
    let cancelled = false;
    let requestGen = 0;
    const apply = () => {
      const ticket = ++requestGen;
      loadLauncherIconUrl({ assetId, tenantId })
        .then(result => {
          if (cancelled || ticket !== requestGen) return;
          if (result.generation !== launcherIconGeneration()) return;
          setSrc(result.url || '');
        })
        .catch(() => {
          if (!cancelled && ticket === requestGen) setSrc('');
        });
    };
    apply();
    const unsubscribe = subscribeLauncherIconCache(() => {
      if (cancelled) return;
      setSrc('');
      apply();
    });
    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, [assetId, tenantId]);

  if (!src) return fallback;
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        width: 'min(86%, 100%)',
        height: 'min(86%, 100%)',
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
        bgcolor: 'transparent',
        ...sx,
      }}
    />
  );
}
